import { useEffect, useState } from "react";
import { isConnected } from "../../Upshow";
import { CLOSE } from "../../utils/keys";

export default function useKeyboardNavigation(openSetup, closeSetup, isOpen) {
    const [connected, setConnected] = useState(isConnected());

    // Listen for connection state changes (instant sync)
    useEffect(() => {
        const handleConnectionChange = (e) => {
            setConnected(e.detail.connected);
            // If internet comes up again and modal is open, close the modal
            if (e.detail.connected && isOpen) closeSetup();
        };

        window.addEventListener('connectionchange', handleConnectionChange);
        return () => {
            window.removeEventListener('connectionchange', handleConnectionChange);
        };
    }, [isOpen, closeSetup]);

    // Register keyboard listener only when NOT connected
    useEffect(() => {
        if (connected) return;

        const OPEN = new Set(["ArrowUp"]);

        let rafId = null;
        let pending = null;

        const flush = () => {
            rafId = null;
            const a = pending;
            pending = null;
            if (a === "close") closeSetup();
            else if (a === "open") openSetup();
        };

        const handle = (e) => {
            // When modal is OPEN, only handle close keys
            if (isOpen) {
                if (CLOSE.has(e.key)) {
                    e.stopPropagation();
                    if (e.key === "Backspace") e.preventDefault?.();
                    pending = "close";
                    if (rafId == null) rafId = requestAnimationFrame(flush);
                }
                // Let other keys pass through for spatial navigation
                return;
            }

            // When modal is CLOSED, handle open keys
            if (OPEN.has(e.key)) {
                e.stopPropagation();
                if (pending !== "close") {
                    pending = "open";
                    if (rafId == null) rafId = requestAnimationFrame(flush);
                }
            }
        };

        window.addEventListener("keydown", handle, { capture: true, passive: false });
        return () => {
            window.removeEventListener("keydown", handle, { capture: true });
            if (rafId != null) cancelAnimationFrame(rafId);
        };
    }, [connected, openSetup, closeSetup, isOpen]);
}
